var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "messaging-description-container" }, [
    _c(
      "div",
      { staticClass: "messaging-description-container-data" },
      [
        _c(
          "div",
          { staticClass: "checkbox-wrapper" },
          [
            _c(
              "vwc-formfield",
              { staticClass: "description-checkBox" },
              [
                _c("vwc-checkbox", {
                  staticClass: "cta-checkbox",
                  attrs: { checked: _vm.isAckChecked, disabled: _vm.disabled },
                  on: { click: _vm.ackChecked },
                }),
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "header", class: { disabled: _vm.disabled } },
              [_vm._v(_vm._s(_vm.header))]
            ),
            _c("cd-tooltip", {
              staticClass: "icon",
              attrs: {
                "tool-tip-info": _vm.toolTipInfo,
                id: _vm.toolTipInfo.id,
              },
            }),
          ],
          1
        ),
        _vm._t("messaging-description-check-box-body"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }